import { render, staticRenderFns } from "./computers.vue?vue&type=template&id=07b0ee9e&"
import script from "./computers.vue?vue&type=script&lang=js&"
export * from "./computers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports